module.exports = __webpack_public_path__ + "static/media/img3.f52b1d82.png";